import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface LabelValueProps {
    title: string;
    value: string | number;
    direction?: 'row' | 'column';
    gap?: number;
    align?: 'flex-start' | 'center' | 'flex-end';
}

const LabelValue: React.FC<LabelValueProps> = ({ title, value, direction = 'row', gap = 0.5, align = 'baseline' }) => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: direction,
                alignItems: align,
                gap,
            }}
        >
            <Typography variant="body1" color="text.disabled">
                {title}
            </Typography>
            {t('separator.colon')}
            <Typography variant="body1" color="text.primary">
                {value}
            </Typography>
        </Box>
    );
};

export default LabelValue;
